<template>
  <div>
    Query: {{this.$route.params.query}}
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/routes/search-items.vue